import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { tap, switchMap, map } from 'rxjs/operators';
import { Service, LoyaltyCard } from './catalogs.model';

@Injectable({
  providedIn: 'root'
})
export class LoyaltyCardsService {
  private uri = environment.url;
  private _cards = new BehaviorSubject(null);

  get cards() {
    return this._cards.asObservable();
  }

  constructor(private http: HttpClient) {}

  fetchCatalogCard(catalogId: string): Observable<LoyaltyCard[]> {
    return this.http.get(this.uri + '/api/v1/loyalty-card').pipe(
      map((resp: any) => {
        const { items } = resp.result;
        return items.filter(card => card.catalog.id === catalogId);
      })
    );
  }

  fetchCards(): Observable<LoyaltyCard[]> {
    return this.http
      .get(this.uri + '/api/v1/loyalty-card')
      .pipe(
        tap((resp: any) => {
          const { items } = resp.result;
          this._cards.next(items);
        }, () => this._cards.next([]))
      );
  }

  resetCard(card: string): Observable<LoyaltyCard[]> {
    return this.http
      .put(this.uri + '/api/v1/loyalty-card/' + card + '/reset', null)
      .pipe(switchMap(() => this.fetchCards()));
  }

  deleteCard(card: string): Observable<LoyaltyCard[]> {
    return this.http
      .delete(this.uri + '/api/v1/loyalty-card/' + card)
      .pipe(switchMap(() => this.fetchCards()));
  }
}
